<template>
  <div>

    <el-card >
      <div slot="header" class="flex flex-between flex-v-center">
        <h4>{{ $t('我的模考') }}</h4>
        <el-button @click="goMock()" icon="el-icon-right" v-if="$store.state.mode == 'CCL'"
          type="primary">开始模考</el-button>
      </div>
      <div class="margin-t" v-if="list.length > 0">

        <div v-for="(item, index1) in list" :key="index1" @click="to1(item)" :class="{ 'bb': index1 < list.length - 1 }"
          class="mock-item on">
          <div class="flex flex-between flex-v-center" style="height:100%">
            <div>
              <h5 v-if="$store.state.mode == 'CCL'" style="margin-left:8px;"> {{ item.ccl_mock ? $t1(item.ccl_mock,
                'title').replace('\\n', '&') : $t1(item.mock, 'title').replace('\\n', '&') }}
              </h5>
              <h5 v-else>{{ item.mock.flag == 1 ? `【${$t('VIP')}】` : `【${$t('免费')}】` }}{{ $t1(item.mock, 'title') }}
              </h5>
              <div class="flex flex-v-center margin-t">
                <div style="font-size: 12px;margin-left:8px;">{{ item.finished_at }}</div>
                <div v-if="item.status > 0" style="font-size: 12px;margin-left:40px;">{{ $t('完成时间') }}：{{
                  item.finished_at }}</div>

              </div>
            </div>
            <div class="flex flex-v-center">
              <div class="margin-r">
                <el-button @click.stop="remove(item)" round type="primary" plain icon="el-icon-delete" size="small"
                  v-if="item.status == 3">删除</el-button>
              </div>
              <h5 v-if="item.status == 1">【{{ $t('已完成') }}】</h5>
              <h5 v-if="item.status == 3">【{{ $t('已评分') }}】</h5>
              <h5 v-else-if="item.status == 2">【{{ $t('打分中') }}】</h5>
              <h5 v-else-if="item.status == 1">【{{ $t('未打分') }}】</h5>
              <h5 v-else>【{{ $t('进行中') }}】</h5>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else></el-empty>
    </el-card>


    <el-card class="margin-lt" v-if="$store.state.mode == 'PTE'">
      <h4>{{ $t('PTE模考') }}</h4>
      <el-tabs :stretch="true" class="margin-t" @tab-click="handleClick" v-model="selectedTab">
        <el-tab-pane v-for="(type, index) in $store.state.mockTypes" :key="index" :label="$t1(type, 'title')"
          :name="index.toString()">
          <div :class="{ 'bb': index1 < type.items.length - 1 }" :id="type.title" v-for="(item, index1) in type.items"
            :key="index1" @click="to(item)" class="mock-item">
            <div class="flex flex-between flex-v-center" style="height:100%">
              <div class="flex flex-v-center">
                <h5>{{ item.flag == 1 ? `【VIP】` : `【${$t('免费')}】` }}{{ $t1(item, 'title') }}</h5>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog top="20%" v-if="centerDialogVisible" custom-class="br" :visible.sync="centerDialogVisible"
      :close-on-click-modal="false" :show-close="false" width="30%" center>
      <h4 slot="title">{{ $t('正在进行') }}</h4>

      <div class="center st1">{{ $t1(item.mock || item.ccl_mock, 'title').replace('\\n', '&') }}</div>

      <span slot="footer" class="dialog-footer center">
        <el-button size="small" @click="centerDialogVisible = false">{{ $t('取 消') }}</el-button>
        <el-button size="small" class="margin-x" type="danger" @click="drop">{{ $t('放 弃') }}</el-button>
        <el-button size="small" type="primary" @click="to(item.mock || item.ccl_mock)">{{ $t('继 续') }}</el-button>
      </span>
    </el-dialog>


    <el-drawer center :visible.sync="drawer" size="50%" :with-header="false">
      <div style="height: 100vh; overflow: hidden;display: flex;flex-direction: column;">
        <div>
          <div class="flex flex-h-center padding">
            <h3 class="lt">{{ $t('选择模考题目') }}</h3>
          </div>
        </div>

        <div class="drawer flex1" style="overflow-y: scroll;" v-loading="loading">
          <div class="margin-l">
            <el-checkbox-group v-model="checkList" :max="2">
              <div v-for="(item, index) in sources" :key="index">
                <div class="flex padding-s flex-v-center pointer">
                  <el-checkbox :label="item.id">{{ index + 1 }}</el-checkbox>
                  <div class="flex flex1 flex-between" @click="setCheck(item.id)">
                    <div class="flex flex-v-center st1">

                      <div class="margin-l">{{ item.title }}</div>

                      <div class="flex">
                        <el-tag type="primary" effect="dark" size="small" class="margin-ls">#{{ item.no }}</el-tag>
                        <el-tag effect="dark" size="small" v-if="item.frequency == 1" class="margin-ls"
                          type="primary">{{
                            $t('高频') }}</el-tag>
                        <el-tag effect="dark" size="small" v-if="item.is_gmat" class="margin-ls" type="primary">{{
                          $t('机经')
                        }}</el-tag>
                        <el-tag effect="dark" size="small" v-if="item.is_new" class="margin-ls" type="primary">{{
                          $t('新题')
                        }}</el-tag>
                      </div>
                    </div>

                    <div class="flex flex-v-center">
                      <i v-if="item.is_vip && $store.getters.getRole() == 0" class="el-icon-lock"></i>
                      <div class="margin-l" v-if="item.favorite">
                        <i v-for="index1 in item.favorite.stars" style="color:rgb(247, 186, 42)" :key="index1"
                          class="el-icon-star-on"></i>
                      </div>

                      <el-tag v-if="item.records_count" type="success" class="margin-l">{{ $t('已练') }}{{
                        item.records_count
                      }}{{ $t('次') }}</el-tag>
                      <el-tag v-else type="success" class="margin-l">{{ $t('未练习') }}</el-tag>
                    </div>
                  </div>
                </div>
                <div class="line"></div>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="flex flex-h-center padding">
          <el-button type="primary" plain round class="margin-r" @click="random()">{{ $t('随机选题') }}</el-button>
          <el-button type="primary" round :disabled="checkList.length < 2" class="margin-l" @click="gotoMock()">{{
            $t('开始模考')
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { random } from 'lodash';


export default {
  data() {
    return {
      selectedTab: localStorage.getItem("mocks_tab") || "0",
      types: [],
      list: [],
      centerDialogVisible: false,
      item: { mock: {} },
      drawer: false,
      sources: [],
      checkList: [],
      loading: false,
    };
  },

  created() {
    this.$store.dispatch("fetch_mock_types");
    this.query();
  },

  methods: {
    random() {
      this.checkList = []
      while (this.checkList.length < 2) {
        const index = random(0, this.sources.length - 1)
        if (this.checkList.indexOf(this.sources[index].id) == -1) {
          this.checkList.push(this.sources[index].id)
        }
      }
    },
    gotoMock() {
      this.$http.post("/api/mock/record", {
        mock_id: this.checkList.join(',')
      }).then(info => {
        this.drawer = false;
        this.checkList = [];
        this.$router.push('/main/ccl?tag=mock&mock_id=' + info.id)
      })
    },
    setCheck(index) {
      const i = this.checkList.indexOf(index);
      if (i > -1) {
        this.checkList.splice(i, 1);
      } else {
        if (this.checkList.length == 2) return
        this.checkList.push(index);
      }
    },
    goMock() {
      if (this.list.length > 0 && this.list[0].status == 0) {
        this.item = this.list[0];
        this.centerDialogVisible = true;
      } else {
        if (this.sources.length == 0) {
          this.drawer = true
          this.loading = true
          this.$http.post("/api/source/list", { tag: 'mock', type: 1 }).then((res) => {
            this.sources = res.data
            this.loading = false
          })
        } else {
          this.drawer = true
        }
      }
    },
    handleClick() {
      localStorage.setItem("mocks_tab", this.selectedTab)
    },
    query() {
      this.$http.post("/api/mock/record/list").then((list) => {
        this.list = list;
      })
    },

    to1(item) {
      if (item.status == 0) {
        this.item = item;
        this.centerDialogVisible = true;
      } else {

        if (this.$store.state.mode == 'CCL') {
          this.$router.push("/main/ccl/record?id=" + item.id);
        } else {
          this.$router.push("/main/mock/record?id=" + item.id);
        }
      }
    },

    remove(item) {
      this.$confirm('', this.$t('确认删除此模考记录') + '?', {
        center: true,
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'primary'
      }).then(() => {
        this.$http.post("/api/mock/record/remove", { id: item.id }).then(() => {
          this.query();
        })
      });
    },

    drop() {
      this.centerDialogVisible = false;
      this.$confirm('', this.$t('确认放弃此次模考记录') + '?', {
        center: true,
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'primary'
      }).then(() => {
        this.$http.post("/api/mock/record/remove", { id: this.item.id }).then(() => {
          this.query();
        })
      });
    },

    to(item) {
      this.centerDialogVisible = false;
      if (this.$store.state.mode == 'CCL') {
        this.$router.push('/main/ccl?tag=mock&mock_id=' + item.id)
        return
      }

      if (item.flag == 1 && this.$store.getters.getRole() == 0) {
        this.$vip_alert("此考卷仅限VIP使用", "")
      } else {
        let url = this.$router.resolve({
          path: '/mock',
          query: { id: item.id }
        })
        window.open(url.href, '_blank')
      }
    }
  },
};
</script>

<style scoped>
.mock-item {
  cursor: pointer;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.mock-item.bb {
  margin-bottom: 15px;
}

.mock-item:hover,
.mock-item.on {
  border: 1px solid #e6a13c;
  color: #e6a13c;
}
</style>
